import React, { useEffect, useState } from "react";
import {
  getClasificacionDocumentos,
  postClasificacionDocumentos,
  //deleteClasificacionDocumentos,
  putClasificacionDocumentos,
} from "../../componentes/http/actions/ClasificacionDocumentoAction";
import EditNoteIcon from "@mui/icons-material/EditNote";
//import IconButton from '@mui/material/IconButton';
import {
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Grid,
  Typography,
  Box,
  Button,
  Snackbar,
  Alert,
  TablePagination,
  CircularProgress,
  Chip,
  Tooltip,
} from "@mui/material";
import NuevoClasificacionDocumentoModal from "../../componentes/modal/ClasificacionDocumento/NuevoClasificacionModal";
import EditarClasificacionDocumentoModal from "../../componentes/modal/ClasificacionDocumento/EditarClasificacionModal";
import FilterComponent from "../../componentes/data/FilterComponent";
const GestorClasificacionDocumento = () => {
  const [clasificacionDocumentos, setClasificacionDocumentos] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [clasificacionSeleccionado, setClasificacionSeleccionado] =
    useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterHabilitado, setFilterHabilitado] = useState("todos");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    fetchClasificacionDocumentos();
  }, []);

  const fetchClasificacionDocumentos = () => {
    setIsLoading(true);
    getClasificacionDocumentos(localStorage.getItem("token"))
      .then((response) => {
        setClasificacionDocumentos(response);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
        setInitialDataLoaded(true);
      });
  };

  const filterOptions = [
    { value: "todos", label: "Todos" },
    { value: "habilitado", label: "Habilitados" },
    { value: "deshabilitado", label: "Deshabilitados" },
  ];

  const filteredClasificacion = clasificacionDocumentos
    .filter((clasificacion) => {
      const matchesSearch = clasificacion.nombre
        .toLowerCase()
        .includes(searchTerm.toLowerCase());
      const matchesFilter =
        filterHabilitado === "todos" ||
        (filterHabilitado === "habilitado" &&
          clasificacion.habilitado === true) ||
        (filterHabilitado === "deshabilitado" &&
          clasificacion.habilitado === false);
      return matchesSearch && matchesFilter;
    })
    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  const handleSearchChange = (newSearchTerm) => {
    setSearchTerm(newSearchTerm);
    setPage(0); // Volver a la primera página al buscar
  };
  
  const handleFilterChange = (newFilter) => {
    setFilterHabilitado(newFilter);
    setPage(0); // Volver a la primera página al filtrar
  };

  //Modal de nuevo clasificacion de documento
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  //Modal de editar clasificacion de documento
  const handleOpenEditModal = (clasificacion) => {
    setClasificacionSeleccionado(clasificacion);
    setOpenEditModal(true);
  };
  const handleCloseEditModal = () => {
    setOpenEditModal(false);
    setClasificacionSeleccionado(null);
  };

  const handleNuevoClasificacion = async (nuevo) => {
    try {
      setIsLoading(true);
      
      await postClasificacionDocumentos(localStorage.getItem("token"), nuevo);
      
      await fetchClasificacionDocumentos();
      handleCloseModal();
      setSnackbar({
        open: true,
        message: "Clasificación de documento agregada con éxito",
        severity: "success",
      });
    } catch (error) {
      console.error("Error al agregar nueva clasificación de documento:", error);
      
      let errorMessage = "Error al agregar clasificación de documento: clasificación ya existe o error en el servidor";
      if (error.response && error.response.data && error.response.data.message) {
        errorMessage = error.response.data.message;
      }
      
      setSnackbar({
        open: true,
        message: errorMessage,
        severity: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditarClasificacion = async (editado) => {
    try {
      setIsLoading(true);
      await putClasificacionDocumentos(localStorage.getItem("token"), editado);
      await fetchClasificacionDocumentos();
      handleCloseEditModal(); // Close the modal after successful edit
      setSnackbar({
        open: true,
        message: "Clasificación de documento editado con éxito",
        severity: "success",
      });
    } catch (error) {
      console.error("Error al editar clasificación de documento:", error);
      setSnackbar({
        open: true,
        message: "Error al editar clasificación de documento: clasificación ya existe o error en el servidor",
        severity: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Grid container direction="column" spacing={2} sx={{paddingTop: {xs: '20px', sm: '10px'}}}>
      <Grid item>
        <Grid container justifyContent="space-between" alignItems="center">
          <Typography variant="h4">Clasificación de Documento</Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={handleOpenModal}
            disabled={isLoading}
          >
            Añadir clasificación de documento
          </Button>
        </Grid>
      </Grid>
      <Grid item>
        <FilterComponent
          searchTerm={searchTerm}
          onSearchChange={handleSearchChange}
          filterValue={filterHabilitado}
          onFilterChange={handleFilterChange}
          filterOptions={filterOptions}
        />
      </Grid>
      <Grid item>
        <TableContainer component={Paper}>
        {isLoading && !initialDataLoaded ? (
        <Box display="flex" justifyContent="center" p={3}>
          <CircularProgress />
        </Box>
      ) : filteredClasificacion.length > 0 ? (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Id</TableCell>
                  <TableCell>Nombre</TableCell>
                  <TableCell>Habilitado</TableCell>
                  <TableCell sx={{ display: "flex", justifyContent: "center" }}>
                    Acciones{" "}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredClasificacion.map((clasificacion, index) => (
                  <TableRow key={index}>
                    <TableCell>{clasificacion.id}</TableCell>
                    <TableCell>{clasificacion.nombre}</TableCell>
                    <TableCell>
                      <Chip
                        label={clasificacion.habilitado ? "Sí" : "No"}
                        color={clasificacion.habilitado ? "success" : "error"}
                        size="small"
                      />
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
                        <Tooltip title="Editar clasificación de documento">
                          <Button
                            size="small"
                            color="primary"
                            sx={{ mr: 1 }}
                            onClick={() => handleOpenEditModal(clasificacion)}
                          >
                            <EditNoteIcon />
                          </Button>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <Box p={3}>
              <Typography variant="body1">
                No se encontraron clasificaciones de documentos con los
                criterios de búsqueda actuales.
              </Typography>
            </Box>
          )}
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          component="div"
          count={clasificacionDocumentos
            .filter((clasificacion) => {
              const matchesSearch = clasificacion.nombre
                .toLowerCase()
                .includes(searchTerm.toLowerCase());
              const matchesFilter =
                filterHabilitado === "todos" ||
                (filterHabilitado === "habilitado" &&
                  clasificacion.habilitado === true) ||
                (filterHabilitado === "deshabilitado" &&
                  clasificacion.habilitado === false);
                return matchesSearch && matchesFilter;
              }).length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Grid>
      <NuevoClasificacionDocumentoModal
        open={openModal}
        onClose={handleCloseModal}
        onGuardar={handleNuevoClasificacion}
      />
      <EditarClasificacionDocumentoModal
        open={openEditModal}
        onClose={handleCloseEditModal}
        clasificacion={clasificacionSeleccionado}
        onGuardar={handleEditarClasificacion}
      />
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default GestorClasificacionDocumento;
